class InstagramFeed {
  constructor() {
    this.initInstagram();

    document.addEventListener('shopify:section:load', () => {
      this.initInstagram();
    });
  }

  initInstagram() {
    const feedWrapper = document.getElementById('FeedWrapper');

    if (!feedWrapper) {
      return;
    }

    const feedLimit = feedWrapper.dataset.feedLimit;
    const feedArray = [];

    // fetch(`https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=${Shopify.shop}&resource=default`)
    fetch(`https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=boutique-camping-uk.myshopify.com&resource=default`)
      .then((response) => response.json())
      .then((media) => {

        // Build new array with section limit in place.
        Object.entries(media).slice(0, feedLimit).map((entry) => {
          return feedArray.push(entry[1]);
        });


        feedArray.forEach((item) => {

          const feedItem = `
            <div class="instagram-feed__item">
              <a href="${item.permalink}" target="_blank" rel="noopener noreferrer">
              ${item.media_type === 'IMAGE'
                ? `<img class="instagram-feed__image" src="${item.media_url}" alt="" height="350" width="350" loading="lazy">`
                : `<video class="instagram-feed__video" poster="${item.thumbnail_url}" height="350" width="350" preload="none" muted playsinline autoplay loop>
                  <source src="${item.media_url}" type="video/mp4">
                </video>`}
              </a>
            </div>
          `;

          feedWrapper.insertAdjacentHTML('beforeend', feedItem);
        });
      })
      .catch((error) => {
        console.error(error);
      });

  }
}

export default InstagramFeed;
